import type { AsyncData } from "#app";
import type { NitroFetchOptions } from "nitropack";
import type { UseApiFetchOptions } from "@edco/apollo/dist/runtime/composables/useApiFetch";

export type SignUpResponse = {
  message: string;
};

export function $newsletterApiResource() {
  const dependencies = useFetchDependencies();

  function signUp(emailAddress: string) {
    const url = "/api/isn/newsletters/signup";

    const body = { emailAddress };

    const options: NitroFetchOptions<string> = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body),
    };

    return $apiFetch<SignUpResponse>(url, options, dependencies);
  }

  return {
    signUp,
  };
}

export function useNewsletterApiResource() {
  function signUp(emailAddress: string): AsyncData<SignUpResponse, Error | null> {
    const url = `/api/isn/newsletters/signup`;

    const options: UseApiFetchOptions<SignUpResponse> = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: { emailAddress }
    };

    return useApiFetch<SignUpResponse>(url, options);
  }

  return {
    signUp,
  };
}
